import { gameLayers } from "game-layers";
import { TGRBalanceWrapTransition } from "transitions/tgr-balance-wrap-transition";
import { TGRBetScreenSceneTransition } from "transitions/tgr-bet-screen-scene-transition";
import { TGRHeaderTransition } from "transitions/tgr-header-transition";
import { TGRInstantWinsSceneTransition } from "transitions/tgr-instant-wins-scene-transition";
import { TGRPCRewatchBetBarTransition } from "transitions/tgr-pc-rewatch-betbar-transition";
import { TGRSpineBigWinTransition } from "transitions/tgr-spine-big-win-transition";

export function TGRSetupTransitions() {
    gameLayers.Header.setTransitions("header", new TGRHeaderTransition(gameLayers.Header));
    gameLayers.BetBar.setTransitions("base", new TGRBalanceWrapTransition(gameLayers.BetBar));
    gameLayers.BetBar.setTransitions("freespins", new TGRBalanceWrapTransition(gameLayers.BetBar));
    gameLayers.BetBar.setTransitions("base", new TGRPCRewatchBetBarTransition(gameLayers.BetBar));
    gameLayers.Menus.setTransitions("bet_screen", new TGRBetScreenSceneTransition(gameLayers.Menus));
    gameLayers.InstantWins.setTransitions("instant_win", new TGRInstantWinsSceneTransition(gameLayers.InstantWins));
    gameLayers.CelebrationContent.setTransitions("bigWin", new TGRSpineBigWinTransition(gameLayers.CelebrationContent, "celebrations", "bw"));
    gameLayers.CelebrationContent.setTransitions("megawin", new TGRSpineBigWinTransition(gameLayers.CelebrationContent, "celebrations", "ew"));
    gameLayers.CelebrationContent.setTransitions("supermegawin", new TGRSpineBigWinTransition(gameLayers.CelebrationContent, "celebrations", "sew"));
}
